import { Icon } from '@iwoca/orion';
import clsx from 'clsx';
import { TApplication } from 'lendingApi/applications.types';
import { TProgressBarStep, getApplicationSteps } from './ProgressBar.helpers';
import styles from './ProgressBar.module.css';

export type TProgressBarProps = {
  status: TApplication['status'];
  className?: string;
};

export const ProgressBar = ({ status, className }: TProgressBarProps) => {
  const renderProgress = ({ label, progress }: TProgressBarStep) => {
    return (
      <div
        data-testid={`${progress}-step`}
        key={label}
        className={clsx(styles.progress, styles[progress])}
      >
        <div className={styles.icon}>
          {progress === 'done' ? (
            <Icon icon="checkDefault" className={styles.checkIcon} />
          ) : progress === 'failed' ? (
            <Icon icon="timesDefault" className={styles.cancelIcon} />
          ) : (
            ''
          )}
        </div>
        <span className={styles.label}>{label}</span>
      </div>
    );
  };

  return (
    <div className={clsx(styles.applicationProgressBar, className)}>
      {getApplicationSteps(status).map((progress) => renderProgress(progress))}
    </div>
  );
};
